import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "../../../../components/Form/TextField";
import CardContainer from "../../../../components/Card/CardContainer";
import SectionHeader from "./SectionHeader";
import {
  SECTION_TARGET_AUDIENCE_TITLE,
  SECTION_TARGET_AUDIENCE_SUBTITLE,
  SECTION_TARGET_AUDIENCE_ICP_LABEL,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import { Target } from "lucide-react";
import { BRAND_EDIT_MULTILINE_ROWS } from "../utils/constants";

export const ICPSection = ({ formMethods, hasError = false }) => {
  const { t } = useTranslationApp();
  const [isEditing, setIsEditing] = useState(false);
  const [editedIcp, setEditedIcp] = useState("");

  const businessIdealCustomerProfile =
    formMethods?.watch?.("businessIdealCustomerProfile") || "";

  useEffect(() => {
    if (!isEditing && formMethods?.control) {
      setEditedIcp(businessIdealCustomerProfile);
    }
  }, [businessIdealCustomerProfile, isEditing, formMethods?.control]);

  useEffect(() => {
    if (formMethods?.control) {
      setEditedIcp(businessIdealCustomerProfile);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formMethods?.control]);

  if (!formMethods || !formMethods.control) {
    return null;
  }

  const { control, errors, validationRules } = formMethods;

  const onSave = () => {
    if (!formMethods?.setValue) return;
    formMethods.setValue("businessIdealCustomerProfile", editedIcp);
    setIsEditing(false);
  };

  const onEdit = async () => {
    setIsEditing(true);
    await formMethods.trigger?.(["businessIdealCustomerProfile"]);
  };

  return (
    <CardContainer title="" hasError={hasError}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          minHeight: "100%",
        }}
      >
        {/* Header */}
        <SectionHeader
          icon={Target}
          title={SECTION_TARGET_AUDIENCE_TITLE}
          subtitle={SECTION_TARGET_AUDIENCE_SUBTITLE}
          isEditing={isEditing}
          onEdit={onEdit}
          onSave={onSave}
        />

        {/* Content */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
          {isEditing ? (
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 1, flex: 1 }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "text.primary",
                  fontSize: "14px",
                  display: "block",
                }}
              >
                {t(SECTION_TARGET_AUDIENCE_ICP_LABEL)}
              </Typography>
              <TextField
                control={control}
                variant="filled"
                name="businessIdealCustomerProfile"
                value={editedIcp}
                actionsChange={(value) => setEditedIcp(value)}
                rules={validationRules.businessIdealCustomerProfile}
                errors={errors}
                multiline
                minRows={BRAND_EDIT_MULTILINE_ROWS}
                maxRows={BRAND_EDIT_MULTILINE_ROWS}
                fullWidth
              />
            </Box>
          ) : (
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                lineHeight: 1.6,
                fontSize: "0.875rem",
                flex: 1,
              }}
            >
              {businessIdealCustomerProfile}
            </Typography>
          )}
        </Box>
      </Box>
    </CardContainer>
  );
};

export default ICPSection;
